@if (label) {
<label class="field-label">
  {{ label }}
  @if (isRequired) {
    <span class="text-red-600" aria-hidden="true">*</span>
  }
</label>
}
<div
  class="date-field-grid mt-2"
  (change)="markTouched()"
>
 
   <!-- Years -->
  <div class="date-field-column">
    <label class="date-field-label">{{ "OWNER_FORM.YEAR" | translate }}</label>
    <ng-select
      #inputElement
      class="date-field-select"
      [formControl]="control.get('year')"
      [items]="years"
      bindLabel="label"
      bindValue="value"
      [clearable]="true"
      (change)="updateMonths(); checkAndEmitDate()"
    >
      <ng-template ng-option-tmp let-item="item">
        <span class="font-light">{{ item.label }}</span>
      </ng-template>
      <ng-template ng-label-tmp let-item="item">
        {{ item.label }}
      </ng-template>
    </ng-select>
  </div>

  <!-- Month -->
  <div class="date-field-column">
    <label class="date-field-label">{{ "OWNER_FORM.MONTH" | translate }}</label>
    <ng-select
      class="date-field-select"
      [formControl]="control.get('month')"
      [items]="months"
      bindLabel="label"
      bindValue="value"
      [clearable]="true"
      (change)="updateDays(); checkAndEmitDate()"
    >
      <ng-template ng-option-tmp let-item="item">
        <span class="font-light">{{ item.label }}</span>
      </ng-template>

      <ng-template ng-label-tmp let-item="item">
        {{ item.label }}
      </ng-template>
    </ng-select>
  </div>
 
   <!-- Day -->
  <div class="date-field-column">
    <label class="date-field-label">{{ "OWNER_FORM.DAY" | translate }}</label>
    <ng-select
      class="date-field-select"
      [formControl]="control.get('day')"
      [items]="days"
      bindLabel="label"
      bindValue="value"
      [clearable]="true"
      (change)="checkAndEmitDate()"
    >
      <!-- option rows -->
      <ng-template ng-option-tmp let-item="item">
        <span class="font-light">{{ item.label }}</span>
      </ng-template>

      <!-- what shows when closed -->
      <ng-template ng-label-tmp let-item="item">
        {{ item.label }}
      </ng-template>
    </ng-select>
  </div>
</div>

<!-- Error messages -->
<div class="fields-error-container">
  @if ((controlDay?.touched && controlDay?.invalid) || (controlMonth?.touched && controlMonth?.invalid) || (controlYear?.touched && controlYear?.invalid)) {
    <div>
      {{ "VALIDATION_MSG.FIELD_REQUIRED" | translate }}
    </div>
  }

  @if (hasOcrDateOutOfRangeError) {
    <div>{{ ocrDateOutOfRangeMessage }}</div>
  }
  
  @if (shouldShowCustomErrors) {
    @for (errorKey of errorKeys; track errorKey) {
      @if (getCustomErrorMessage(errorKey)) {
        <div>{{ getCustomErrorMessage(errorKey) }}</div>
      }
    }
  }
</div>
